





import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent} from "@vue/composition-api"
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {bus} from "@/main"
import {getStoredProcedure} from "@/data/repos/storedProcedure"
import {getLocationCaption} from "@/data/sources/appraisal"


export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "ClashingRooms",
    title: "Clashing rooms",
    cType: "text",
    w: 2,
    h: 2,
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

async function titleCallback(config: any) {
  return "Location: " + await getLocationCaption(config.params.locationId)
}

export default defineComponent({
  props: {config: Object},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())

    async function dataFetcher(params: any) {
      const locationId = parseInt(params.locationId.value) || 10
      const userId = 1
      const r = await getStoredProcedure(
        'AnalyticsCenter',
        'widget_ClashingRooms',
        [locationId, userId]) //todo pass all parameters
      return {value: formatNumberWithGrouping(r[0].Value)}
    }

    function chartClickCallback(label: string, val: string, data: any) {
      const locationId = parseInt(props.config && props.config.params.locationId.value)
      const userId = 1
      bus.$emit('chartPopup', {
        title: 'Clashing rooms',
        component: () => import('@/components/widgets/core/ClashingRoomsDrillDown.vue'),
        componentArgs: {locationId, userId},
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
